/* eslint-disable react/jsx-no-target-blank */
import { Button as RoccoButton } from '@rocco/components/button';
import { useWebsiteReferralTracking } from '~/modules/tracking/util/websiteTracking';
import { cn } from '@rocco/utils/cn';

const HIDE_CTA_AND_CONTENT = true;

export const ProfessionalHeroBannerContent = ({
    professional,
    variant = 'default',
}: {
    professional: {
        Title: string;
        Content?: string;
        Website: string;
        ID: number;
        filteredName?: string;
        filteredSymbol?: string;
        afterSymbol?: string;
        hasSymbol: boolean;
    };
    variant?: 'default' | 'compact';
}) => {
    const {
        Title,
        Website,
        ID,
        Content,
        filteredName,
        filteredSymbol,
        afterSymbol,
        hasSymbol,
    } = professional;
    const { referralTrackingURL, referralTrackingParams } =
        useWebsiteReferralTracking(Website, {
            libraryItemID: ID,
            professionalID: ID,
            professionalTitle: Title,
        });

    return (
        <div
            className={cn(
                'absolute left-0 z-sticky flex w-full flex-col px-4 md:mt-[10rem] md:w-[70rem] md:pl-12',
                variant === 'compact' ? 'bottom-0' : 'top-70 md:w-240'
            )}
        >
            <h1
                className={cn(
                    'm-0 max-w-full pb-12 text-[2.75rem] leading-[116%] tracking-[-0.15rem] text-white md:pb-[3.2rem] md:text-20 md:leading-[110%]',
                    variant === 'compact'
                        ? 'text-[2.25rem] md:text-18'
                        : 'text-[2.25rem] font-[500] md:text-21'
                )}
            >
                {hasSymbol ? (
                    <>
                        {filteredName}
                        <span className="mr-5 align-super text-[50%]">
                            {filteredSymbol}
                        </span>
                        {afterSymbol}
                    </>
                ) : (
                    Title
                )}
            </h1>

            {!HIDE_CTA_AND_CONTENT && Content && Content.length > 0 && (
                <div className="pb-12 pr-24 md:max-w-[35.625rem] md:pb-[3.2rem] md:pr-0">
                    <div
                        className="line-clamp-2 h-[2.6em] text-4 leading-[130%] tracking-[0.025rem] text-white md:text-5"
                        dangerouslySetInnerHTML={{
                            __html: Content ?? '',
                        }}
                    />
                </div>
            )}

            {!HIDE_CTA_AND_CONTENT && Website && (
                <div className="flex items-center gap-9">
                    <RoccoButton
                        color="transparent"
                        inverted={true}
                        asChild
                        size={'compact'}
                        shape={'square'}
                    >
                        <a
                            href={referralTrackingURL}
                            target="_blank"
                            {...referralTrackingParams}
                            style={{
                                textDecoration: 'underline',
                                textUnderlineOffset: '0.3rem',
                                letterSpacing: '0.035rem',
                            }}
                        >
                            {'View website'}
                        </a>
                    </RoccoButton>
                </div>
            )}
        </div>
    );
};
